import { useEffect } from "react";
import { FAVICON_ELEMENT_ID } from "@/constants";

function findOrCreateFaviconLink(): HTMLLinkElement {
  const existing = document.getElementById(FAVICON_ELEMENT_ID);
  if (existing instanceof HTMLLinkElement) {
    return existing;
  }
  const link = document.createElement("link");
  link.id = FAVICON_ELEMENT_ID;
  link.rel = "icon";
  document.head.appendChild(link);
  return link;
}

/**
 * Point the browser tab's icon at `href` while the caller is mounted, restoring the previous icon
 * on unmount.
 *
 * Rewrites the one `<link rel="icon">` that `index.html` declares rather than adding another:
 * with two icon links, which one a browser shows is up to the browser.
 */
export function useFavicon(href: string) {
  useEffect(() => {
    const link = findOrCreateFaviconLink();
    const previousHref = link.getAttribute("href");
    link.setAttribute("href", href);
    return () => {
      if (previousHref === null) {
        link.removeAttribute("href");
      } else {
        link.setAttribute("href", previousHref);
      }
    };
  }, [href]);
}
